"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateDiscountedPriceShipment = exports.CalculateDiscountedPriceProduct = exports.CalculateDiscountedPrice = void 0;
function CalculateDiscountedPrice(products, shipmentMethod, discountCodes) {
    discountCodes.sort((a, b) => a.priority - b.priority);
    const amountProducts = products.reduce((total, product) => total + product.priceGross * product.quantity, 0);
    const costProducts = products.reduce((total, product) => total + CalculateDiscountedPriceProduct(product.priceGross, discountCodes) * product.quantity, 0);
    const amountShipment = shipmentMethod.priceGross;
    const costShipment = CalculateDiscountedPriceShipment(amountShipment, discountCodes);
    return {
        amountProducts: amountProducts,
        amountShipment: amountShipment,
        costProduct: costProducts,
        costShipment: costShipment,
        totalDiscounted: costProducts + costShipment,
        total: amountProducts + amountShipment
    };
}
exports.CalculateDiscountedPrice = CalculateDiscountedPrice;
function CalculateDiscountedPriceProduct(productPrice, discountCodes) {
    let discountedPrice = productPrice;
    for (let i = 0; i < discountCodes.length; i++) {
        const { type, amount } = discountCodes[i];
        switch (type) {
            case "percentProduct":
                discountedPrice = discountPercent(discountedPrice, amount);
                break;
        }
    }
    discountedPrice = Math.floor(discountedPrice);
    if (discountedPrice <= 0) {
        return 0;
    }
    return discountedPrice;
}
exports.CalculateDiscountedPriceProduct = CalculateDiscountedPriceProduct;
function CalculateDiscountedPriceShipment(shipmentPrice, discountCodes) {
    let discountedPrice = shipmentPrice;
    for (let i = 0; i < discountCodes.length; i++) {
        const { type, amount } = discountCodes[i];
        switch (type) {
            case "amountShipment":
                discountedPrice -= amount;
                break;
        }
    }
    discountedPrice = Math.floor(discountedPrice);
    if (discountedPrice <= 0) {
        return 0;
    }
    return discountedPrice;
}
exports.CalculateDiscountedPriceShipment = CalculateDiscountedPriceShipment;
function discountPercent(value, amount) {
    return value * (1 - amount / 100);
}
//# sourceMappingURL=CalculateDiscountedPrice.js.map